import * as _ from 'lodash';
import { Aggregate } from '../../../../models/aggregate';
import { EsPage } from '../../../../models/es-page';
import { CdxTask } from '../../../../models/cdx-task';
import {
  loadAggregateFailedAction,
  loadAggregateStartAction,
  loadAggregateSucceededAction,
  loadResultItemsFailedAction,
  loadResultItemsStartAction,
  loadResultItemsSucceededAction,
  removeSomeTasksFailedAction,
  removeSomeTasksStartAction,
  removeSomeTasksSucceededAction,
  TaskSearchResultConstantAction,
  updateSomeTasksFailedAction,
  updateSomeTasksStartAction,
  updateSomeTasksSucceededAction,
  updateTasksFailedAction,
  updateTasksStartAction,
  updateTasksSucceededAction,
  updateTaskSucceededAction
} from '../action/task-search-result.action';

import { createReducer, on } from '@ngrx/store';

export const TASK_SEARCH_RESULT_INITIAL_STATE: TaskSearchResultState = {
  datas: null,
  loading: false,
  loadAgg: false,
  error: null,
};

export interface TaskSearchResultState {
  datas: EsPage<CdxTask>;
  loading: boolean;
  loadAgg: boolean;
  error: any;
}


/*
export const taskSearchResultReducerOld = ( state: TaskSearchResultState = TASK_SEARCH_RESULT_INITIAL_STATE, action: PayloadAction<EsPage<CdxTask>>) => {
  switch (action.type) {
    case TaskSearchResultConstantAction.LOAD_AGGREGATE_START:
      return {
        ...state,
        loading: true,
        loadAgg: true,
        error: TaskSearchResultConstantAction.ERROR_START,
      };
    case TaskSearchResultConstantAction.LOAD_RESULT_ITEMS_START:
    case TaskSearchResultConstantAction.UPDATE_TASKS_START:
      return {
        ...state,
        loading: true,
        error: TaskSearchResultConstantAction.ERROR_START,
      };
    case TaskSearchResultConstantAction.LOAD_RESULT_ITEMS_SUCCEEDED:
      return {
        ...state,
        datas: action.payload,
        loading: false,
        error: null,
      };
    case TaskSearchResultConstantAction.LOAD_RESULT_ITEMS_FAILED:
      return {
        ...state,
        datas: undefined,
        loading: false,
        error: action.error,
      };
    case TaskSearchResultConstantAction.LOAD_AGGREGATE_SUCCEEDED:
      const newAgg: Aggregate = action.payload.aggs[0];
      let aggs: Aggregate[] = state.datas.aggs;
      let added = false;
      aggs = aggs.map(agg => {
        if (agg.path === newAgg.path) {
          added = true;
          return newAgg;
        }
        return agg;
      });
      if (!added) {
        aggs.push(newAgg);
      }
      const copy = {...state.datas, aggs: aggs};
      return {
        ...state,
        datas: copy,
        loading: false,
        loadAgg: false,
        error: null,
      };
    case TaskSearchResultConstantAction.LOAD_AGGREGATE_FAILED:
      return {
        ...state,
        loading: false,
        loadAgg: false,
        error: action.error,
      };
    case TaskSearchResultConstantAction.UPDATE_TASKS_SUCCEEDED:
      return {
        ...state,
        datas: {...state.datas,
          content: action.payload.content,
          numberOfElements: action.payload.numberOfElements,
          size: action.payload.size,
          page: action.payload.page
        },
        loading: false,
        error: null,
      };
    case TaskSearchResultConstantAction.UPDATE_TASKS_FAILED:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
  }
  return state;
};

*/


export const taskSearchResultReducer = createReducer(
  TASK_SEARCH_RESULT_INITIAL_STATE,
  on(loadResultItemsStartAction, (state) => ({
    ...state,
    loading: true,
    error: TaskSearchResultConstantAction.ERROR_START,
  }) ),
  on(loadResultItemsSucceededAction, (state, {payload}) => ({
    ...state,
    datas: payload,
    loading: false,
    error: null,
  }) ),
  on(loadResultItemsFailedAction, (state, {error}) => ({
    ...state,
    datas: undefined,
    loading: false,
    error: error,
  }) ),
  on(loadAggregateStartAction, (state) => ({
    ...state,
    loading: true,
    loadAgg: true,
    error: TaskSearchResultConstantAction.ERROR_START,
  }) ),
  on(loadAggregateSucceededAction, (state, {payload}) => {
    const newAgg: Aggregate = payload.aggs[0];
    let aggs: Aggregate[] = state.datas.aggs;
    let added = false;
    aggs = aggs.map(agg => {
      if (agg.path === newAgg.path) {
        added = true;
        return newAgg;
      }
      return agg;
    });
    if (!added) {
      aggs.push(newAgg);
    }
    const copy = {...state.datas, aggs: aggs};

    return (
    {
    ...state,
    datas: copy,
    loading: false,
    loadAgg: false,
    error: null,
  })} ),
  on(loadAggregateFailedAction, (state, {error} ) => ({
    ...state,
    loading: false,
    loadAgg: false,
    error: error,
  }) ),
  on(updateTasksStartAction, (state) => ({
    ...state,
    loading: true,
    error: TaskSearchResultConstantAction.ERROR_START,
  }) ),
  on(updateTasksSucceededAction, (state, {payload}) => ({

    ...state,
    datas: {...state.datas,
      content: payload.content,
      numberOfElements: payload.numberOfElements,
      size: payload.size,
      page: payload.page
    },
    loading: false,
    error: null,
  }) ),
  on(updateTasksFailedAction, (state, {error}) => ({
    ...state,
    loading: true,
    error: error,
  }) ),
  on(updateTaskSucceededAction, (state, {payload}) => {
    const updatedTask = payload.content[0];
    const contentIndex = state.datas.content.findIndex(cdxTask => cdxTask?.cdx_wkf?.cdx_process?.task_instance_id === updatedTask?.cdx_wkf?.cdx_process?.task_instance_id);

    if (contentIndex !== -1) {
      state.datas.content.splice(contentIndex, 1, updatedTask);
    }

    return {
      ...state,
      datas: {
        ...state.datas,
        content: state.datas.content,
      },
      loading: false,
      loadAgg: false,
      error: null,
    };
  }),
  on(updateSomeTasksStartAction, (state) => ({
    ...state,
    loading: true,
    error: TaskSearchResultConstantAction.ERROR_START,
  }) ),
  on(updateSomeTasksSucceededAction, (state, {payload}) => {
    const datasCopy = _.cloneDeep(state.datas);
    payload.forEach( (updatedTask) => {
      const contentIndex = state.datas.content.findIndex(cdxTask => cdxTask?.cdx_wkf?.cdx_process?.task_instance_id === updatedTask?.cdx_wkf?.cdx_process?.task_instance_id);
          if (contentIndex !== -1) {
            datasCopy.content.splice(contentIndex, 1, updatedTask);
          }
        }
    );

    return {
      ...state,
      datas: datasCopy,
      loading: false,
      loadAgg: false,
      error: null,
    };

  }),
  on(updateSomeTasksFailedAction, (state, {error}) => ({
    ...state,
    loading: true,
    error: error,
  }) ),
  on(removeSomeTasksStartAction, (state) => ({
  ...state,
  loading: true,
  error: TaskSearchResultConstantAction.ERROR_START,
  }) ),
  on(removeSomeTasksSucceededAction, (state, {payload}) => {
    const datasCopy = _.cloneDeep(state.datas);
    payload.forEach( (taskToRemove) => {
          const contentIndex = state.datas.content.findIndex(cdxTask => cdxTask?.cdx_wkf?.cdx_process?.task_instance_id === taskToRemove?.cdx_wkf?.cdx_process?.task_instance_id);
          if (contentIndex !== -1) {
            datasCopy.content.splice(contentIndex, 1 );
          }
        }
    );

    return {
      ...state,
      datas: datasCopy,
      loading: false,
      loadAgg: false,
      error: null,
    };

  }),
  on(removeSomeTasksFailedAction, (state, {error}) => ({
    ...state,
    loading: true,
    error: error,
  }) ),
);
